import styled from 'styled-components'

export const Svg = styled.svg`
  fill: ${({ color }) => color ? color : '#C24728'};
  align-items: baseline;
  height: ${({ height }) => height ? height : '85%' };
  width: ${({ width }) => width ? width : '25%' };
  float: left;
  display: inline-block;

  @media screen and (max-width: 768px) {
    width: ${({ widthResponsive }) => widthResponsive ? widthResponsive : '20%' };
    height: ${({ heightResponsive }) => heightResponsive ? heightResponsive : '85%' };
  }
`